import { Component } from "react";
import type { IntlShape } from "react-intl";
type Props = {
  selectedComps: Record<string, any>;
  handleSubmit: (...args: Array<any>) => any;
  intl: IntlShape;
};

class CompetitionsSubmit extends Component<Props> {
  render() {
    const { selectedComps, handleSubmit, intl } = this.props;
    return (
      <div className="select-competitions__submit">
        <button
          className={`${
            selectedComps.length === 0
              ? "select-competitions__submit__button select-competitions__submit__button--disabled"
              : "select-competitions__submit__button"
          }`}
          type="submit"
          onClick={selectedComps.length !== 0 ? handleSubmit : undefined}
        >
          {intl.formatMessage({
            id: "button-submit",
          })}
        </button>
      </div>
    );
  }
}

export default CompetitionsSubmit;
